var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1889 3.11667L10.9056 0.833337C10.6075 0.553417 10.217 0.392803 9.80833 0.382047C9.39961 0.371291 9.0012 0.511145 8.68889 0.775004L1.18889 8.275C0.919525 8.54664 0.751807 8.90267 0.713886 9.28334L0.355553 12.7583C0.344327 12.8804 0.360165 13.0034 0.401938 13.1187C0.44371 13.2339 0.510388 13.3385 0.59722 13.425C0.675087 13.5022 0.767433 13.5633 0.868965 13.6048C0.970496 13.6463 1.07921 13.6673 1.18889 13.6667H1.26389L4.73889 13.35C5.11955 13.3121 5.47558 13.1444 5.74722 12.875L13.2472 5.375C13.5383 5.06748 13.6956 4.65709 13.6847 4.23378C13.6738 3.81047 13.4955 3.40876 13.1889 3.11667ZM4.58889 11.6833L2.08889 11.9167L2.31389 9.41667L7.02222 4.76667L9.27222 7.01667L4.58889 11.6833ZM10.3556 5.9L8.12222 3.66667L9.74722 2L12.0222 4.275L10.3556 5.9Z",
    fill: "#959FBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7496a24efc66ef3f9bb70ab0782cdd4b.svg";
export { ForwardRef as ReactComponent };